export default "__VITE_ASSET__41ba2f2c__"